import Bloc from './Bloc.js';
import Types from './Types.js';

export default class ShiftMana extends Bloc {

	constructor (src, ctx) {

		super("shiftmana", src, ctx, true);
		this.f = (src, ins) => {
			ins[0].shiftMana(ins[1]);
			return [];
		};
		this.types = [Types.card, Types.int];
	}
}